import { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { roles } from 'helpers/consts';
import useApi from 'hooks/useApi';

const Permissions = () => {
    const api = useApi();
    const [selectedRole, setSelectedRole] = useState(null);
    const [EditingRows, setEditingRows] = useState({});
    const [permissions, setPermissions] = useState([]);
    const rolesFiltered = roles.filter(role => role.id > 1).map(role => ({
        label: role.label,
        value: role.id,
    }));

    const onPermissionChange = (rowData, field, value) => {
        
        const updatedPermissions = permissions.map(permission => {
            if (permission.module === rowData.module) {
                return { ...permission, [field]: value };
            }
            return permission;
        });
        let permission = updatedPermissions.filter(p => p.module === rowData.module)[0];
        api.put(`/permissions/update/${selectedRole}/${rowData.id}`, 
             [permission.create, permission.read, permission.update, permission.delete]
        );
        setPermissions(updatedPermissions);
    };

    const toggleAll = (field) => {
        const allChecked = permissions.every(permission => permission[field]);
        const updatedPermissions = permissions.map(permission => ({
            ...permission,
            [field]: !allChecked,
        }));
        setPermissions(updatedPermissions);
    };

    const renderCheckbox = (rowData, field) => {
        return (
            <Checkbox
                checked={rowData[field]}
                onChange={(e) => onPermissionChange(rowData, field, e.checked)}
            />
        );
    };

    useEffect(() => {
        if (selectedRole) {
            api.get(`/permissions/routers/${selectedRole}`)
                .then(response => {
                    setPermissions(response.data);
                })
                .catch(error => {
                    console.error('Error fetching permissions:', error);
                });
        }
    }, [selectedRole])


    const renderHeaderButton = (field, title) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                    <div>{title}</div>
                    <Button
                        icon={permissions.every(permission => permission[field]) ? 'pi pi-times' : 'pi pi-check'}
                        onClick={() => toggleAll(field)}
                        className="p-button-text"
                    />
                </div>
            </div>
        );
    };

    const handleRowEditComplete = (e) => {
    }

    return (
        <div>
            <div className="p-field" style={{ marginBottom: '20px' }}>
                <Dropdown
                    id="role"
                    value={selectedRole}
                    options={rolesFiltered}
                    onChange={(e) => setSelectedRole(e.value)}
                    placeholder="Selecione um perfil"
                    style={{ width: '200px' }}
                />
            </div>
            <h2>Permissões de Perfis de Acesso</h2>

            <DataTable value={permissions} 
                editable 
                editMode="row" 
                dataKey="id"
                editingRows={EditingRows}
                onRowEditComplete={handleRowEditComplete} 
                onRowEditChange={(e) => {
                    console.log('Row edit change:', e.data);
                }}
                className="p-datatable-sm"


            >

                <Column field="title" header="Módulo" style={{ width: '50%' }}></Column>
                <Column
                    field="create"
                    header={renderHeaderButton('create', 'Criar')}
                    body={(rowData) => renderCheckbox(rowData, 'create')}
                    style={{ width: '5%' }}
                ></Column>
                <Column
                    field="read"
                    header={renderHeaderButton('read', 'Ler')}
                    body={(rowData) => renderCheckbox(rowData, 'read')}
                    style={{ width: '5%' }}
                ></Column>
                <Column
                    field="update"
                    header={renderHeaderButton('update', 'Atualizar')}
                    body={(rowData) => renderCheckbox(rowData, 'update')}
                    style={{ width: '5%' }}
                ></Column>
                <Column
                    field="delete"
                    header={renderHeaderButton('delete', 'Excluir')}
                    body={(rowData) => renderCheckbox(rowData, 'delete')}
                    style={{ width: '5%' }}
                ></Column>
            </DataTable>
        </div>
    );
};

export default Permissions;